let env = {
  'local': {
    
    // 'rest_url': 'http://localhost:8000',
    // 'rest_url': 'https://dbec7a21e8f8.ngrok.io/',
    // 'redirect_url': 'http://localhost:3001',
    'rest_url': 'https://arc-api.scieverinc.com',
    'redirect_url': 'https://admin-dev.arc.com.np',
    'title': 'local'
  },
};
export const config = () => {
  return env['local'] ;
};